/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Case_Payment_Save_ErrorInputs */

const en_case_payment_save_error = /** @type {(inputs: Case_Payment_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not save payment information: ${i?.message}`)
};

const pt_br2_case_payment_save_error = /** @type {(inputs: Case_Payment_Save_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Não foi possível salvar as informações de pagamento: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Could not save payment information: {message}" |
*
* @param {Case_Payment_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_save_error = /** @type {((inputs: Case_Payment_Save_ErrorInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Save_ErrorInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_save_error(inputs)
	return pt_br2_case_payment_save_error(inputs)
});